module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkBAMAAACCzIhnAAAAG1BMVEW8vLwAAACkpKRGRkYvLy91dXUXFxdeXl6NjY29xSPfAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABEklEQVRYhe2STWuDQBCGX79Sj238SI6GQM8Kpb3qP8hCf0AsxVw3kB9Qb/3ZHWcsXbGCt/YwD7jIO/vAzO4CiqIoiqIo/wT/iZZje6G/59zi8Ab+jvUYSM0lalJa25fGYpPcdrhLgOqE1wdSOJCai7mQEmUItzAnNAXaIk4R5VdSOJCayydICe8Hq+FNfU074g+PFA6kNoWUzRn+Dh1NYRFkZuhjUDiQ2lyp4Sd4px0l/K7DqHAgtZnicZyyApN9Kxx4K5TrKmXSWN4VKxqjEWMev6fx96b8Gb+3UpspAR9kJYdchvtR4SD4/ZCnV+nno7Jwlay4D4aaqKwoCw9GFOdZnoHHrSgLz1JRFEVRFOXv+ALaMja2etH4aAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t1.png
// module id = vo0/
// module chunks = 0